// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/httpv2/sandbox.proto (package infinigence.infini.agentplatform.httpv2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ListRequestSchema } from "./common_pb.js";
import { file_agentplatform_httpv2_common } from "./common_pb.js";
import type { Sandbox, SandboxClass, SandboxEnvironment, SandboxSpec, SandboxTool } from "../v1/sandbox_pb.js";
import { file_agentplatform_v1_sandbox } from "../v1/sandbox_pb.js";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb.js";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb.js";
import { file_google_api_annotations } from "../../google/api/annotations_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/httpv2/sandbox.proto.
 */
export const file_agentplatform_httpv2_sandbox: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agentplatform_httpv2_common, file_agentplatform_v1_sandbox, file_buf_validate_validate, file_gnostic_openapi_v3_annotations, file_google_api_annotations]);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSandboxesResponse
 */
export type ListSandboxesResponse = Message<"infinigence.infini.agentplatform.httpv2.ListSandboxesResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListSandboxesData data = 4;
   */
  data?: ListSandboxesData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSandboxesResponse.
 * Use `create(ListSandboxesResponseSchema)` to create a new message.
 */
export const ListSandboxesResponseSchema: GenMessage<ListSandboxesResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 0);

/**
 * List 字段量大，按 spec §3.3 例外条款允许直接复用资源 message。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSandboxesData
 */
export type ListSandboxesData = Message<"infinigence.infini.agentplatform.httpv2.ListSandboxesData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.Sandbox items = 1;
   */
  items: Sandbox[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSandboxesData.
 * Use `create(ListSandboxesDataSchema)` to create a new message.
 */
export const ListSandboxesDataSchema: GenMessage<ListSandboxesData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 1);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateSandboxRequest
 */
export type CreateSandboxRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateSandboxRequest"> & {
  /**
   * Sandbox 实例定义（归属 tenant_id / user_id 由服务端从鉴权信息回填）
   * @gotags: json:"sandbox"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Sandbox sandbox = 1;
   */
  sandbox?: Sandbox | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateSandboxRequest.
 * Use `create(CreateSandboxRequestSchema)` to create a new message.
 */
export const CreateSandboxRequestSchema: GenMessage<CreateSandboxRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 2);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateSandboxResponse
 */
export type CreateSandboxResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateSandboxResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Sandbox data = 4;
   */
  data?: Sandbox | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateSandboxResponse.
 * Use `create(CreateSandboxResponseSchema)` to create a new message.
 */
export const CreateSandboxResponseSchema: GenMessage<CreateSandboxResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 3);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSandboxRequest
 */
export type GetSandboxRequest = Message<"infinigence.infini.agentplatform.httpv2.GetSandboxRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSandboxRequest.
 * Use `create(GetSandboxRequestSchema)` to create a new message.
 */
export const GetSandboxRequestSchema: GenMessage<GetSandboxRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 4);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSandboxResponse
 */
export type GetSandboxResponse = Message<"infinigence.infini.agentplatform.httpv2.GetSandboxResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Sandbox data = 4;
   */
  data?: Sandbox | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSandboxResponse.
 * Use `create(GetSandboxResponseSchema)` to create a new message.
 */
export const GetSandboxResponseSchema: GenMessage<GetSandboxResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 5);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateSandboxRequest
 */
export type UpdateSandboxRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateSandboxRequest"> & {
  /**
   * 待更新 Sandbox 实例 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Sandbox 实例定义（id / 归属由服务端回填）
   * @gotags: json:"sandbox"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Sandbox sandbox = 2;
   */
  sandbox?: Sandbox | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateSandboxRequest.
 * Use `create(UpdateSandboxRequestSchema)` to create a new message.
 */
export const UpdateSandboxRequestSchema: GenMessage<UpdateSandboxRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 6);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateSandboxResponse
 */
export type UpdateSandboxResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateSandboxResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Sandbox data = 4;
   */
  data?: Sandbox | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateSandboxResponse.
 * Use `create(UpdateSandboxResponseSchema)` to create a new message.
 */
export const UpdateSandboxResponseSchema: GenMessage<UpdateSandboxResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 7);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteSandboxRequest
 */
export type DeleteSandboxRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteSandboxRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteSandboxRequest.
 * Use `create(DeleteSandboxRequestSchema)` to create a new message.
 */
export const DeleteSandboxRequestSchema: GenMessage<DeleteSandboxRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 8);

/**
 * 删除幂等：成功 / 不存在都返回 HTTP 200，envelope code "200"，不带 data
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteSandboxResponse
 */
export type DeleteSandboxResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteSandboxResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteSandboxResponse.
 * Use `create(DeleteSandboxResponseSchema)` to create a new message.
 */
export const DeleteSandboxResponseSchema: GenMessage<DeleteSandboxResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 9);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSandboxToolsRequest
 */
export type ListSandboxToolsRequest = Message<"infinigence.infini.agentplatform.httpv2.ListSandboxToolsRequest"> & {
  /**
   * Sandbox 实例 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSandboxToolsRequest.
 * Use `create(ListSandboxToolsRequestSchema)` to create a new message.
 */
export const ListSandboxToolsRequestSchema: GenMessage<ListSandboxToolsRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 10);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSandboxToolsResponse
 */
export type ListSandboxToolsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListSandboxToolsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListSandboxToolsData data = 4;
   */
  data?: ListSandboxToolsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSandboxToolsResponse.
 * Use `create(ListSandboxToolsResponseSchema)` to create a new message.
 */
export const ListSandboxToolsResponseSchema: GenMessage<ListSandboxToolsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 11);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSandboxToolsData
 */
export type ListSandboxToolsData = Message<"infinigence.infini.agentplatform.httpv2.ListSandboxToolsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.SandboxTool items = 1;
   */
  items: SandboxTool[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSandboxToolsData.
 * Use `create(ListSandboxToolsDataSchema)` to create a new message.
 */
export const ListSandboxToolsDataSchema: GenMessage<ListSandboxToolsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 12);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSandboxTraceRecordsRequest
 */
export type ListSandboxTraceRecordsRequest = Message<"infinigence.infini.agentplatform.httpv2.ListSandboxTraceRecordsRequest"> & {
  /**
   * 分页页码
   * @gotags: json:"page,omitempty"
   *
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * 每页大小
   * @gotags: json:"page_size,omitempty"
   *
   * @generated from field: int32 page_size = 2 [json_name = "page_size"];
   */
  pageSize: number;

  /**
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 3 [json_name = "user_id"];
   */
  userId: string;

  /**
   * @gotags: json:"name,omitempty"
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @gotags: json:"session_id,omitempty"
   *
   * @generated from field: string session_id = 5 [json_name = "session_id"];
   */
  sessionId: string;

  /**
   * @gotags: json:"from_timestamp,omitempty"
   *
   * @generated from field: string from_timestamp = 6 [json_name = "from_timestamp"];
   */
  fromTimestamp: string;

  /**
   * @gotags: json:"to_timestamp,omitempty"
   *
   * @generated from field: string to_timestamp = 7 [json_name = "to_timestamp"];
   */
  toTimestamp: string;

  /**
   * @gotags: json:"order_by,omitempty"
   *
   * @generated from field: string order_by = 8 [json_name = "order_by"];
   */
  orderBy: string;

  /**
   * @gotags: json:"tags,omitempty"
   *
   * @generated from field: repeated string tags = 9;
   */
  tags: string[];

  /**
   * @gotags: json:"version,omitempty"
   *
   * @generated from field: string version = 10;
   */
  version: string;

  /**
   * @gotags: json:"release,omitempty"
   *
   * @generated from field: string release = 11;
   */
  release: string;

  /**
   * @gotags: json:"environment,omitempty"
   *
   * @generated from field: repeated string environment = 12;
   */
  environment: string[];

  /**
   * @gotags: json:"fields,omitempty"
   *
   * @generated from field: string fields = 13;
   */
  fields: string;

  /**
   * @gotags: json:"filter,omitempty"
   *
   * @generated from field: string filter = 14;
   */
  filter: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSandboxTraceRecordsRequest.
 * Use `create(ListSandboxTraceRecordsRequestSchema)` to create a new message.
 */
export const ListSandboxTraceRecordsRequestSchema: GenMessage<ListSandboxTraceRecordsRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 13);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSandboxTraceRecordsResponse
 */
export type ListSandboxTraceRecordsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListSandboxTraceRecordsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListSandboxTraceRecordsData data = 4;
   */
  data?: ListSandboxTraceRecordsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSandboxTraceRecordsResponse.
 * Use `create(ListSandboxTraceRecordsResponseSchema)` to create a new message.
 */
export const ListSandboxTraceRecordsResponseSchema: GenMessage<ListSandboxTraceRecordsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 14);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSandboxTraceRecordsData
 */
export type ListSandboxTraceRecordsData = Message<"infinigence.infini.agentplatform.httpv2.ListSandboxTraceRecordsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.httpv2.SandboxTraceRecord items = 1;
   */
  items: SandboxTraceRecord[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSandboxTraceRecordsData.
 * Use `create(ListSandboxTraceRecordsDataSchema)` to create a new message.
 */
export const ListSandboxTraceRecordsDataSchema: GenMessage<ListSandboxTraceRecordsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 15);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.SandboxTraceRecord
 */
export type SandboxTraceRecord = Message<"infinigence.infini.agentplatform.httpv2.SandboxTraceRecord"> & {
  /**
   * @gotags: json:"start_time"
   *
   * @generated from field: int64 start_time = 1 [json_name = "start_time"];
   */
  startTime: bigint;

  /**
   * @gotags: json:"end_time"
   *
   * @generated from field: int64 end_time = 2 [json_name = "end_time"];
   */
  endTime: bigint;

  /**
   * @gotags: json:"status"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.TraceRecordStatus status = 3;
   */
  status: TraceRecordStatus;

  /**
   * @gotags: json:"duration"
   *
   * @generated from field: double duration = 4;
   */
  duration: number;

  /**
   * @gotags: json:"application_id"
   *
   * @generated from field: string application_id = 5 [json_name = "application_id"];
   */
  applicationId: string;

  /**
   * @gotags: json:"sandbox_id"
   *
   * @generated from field: string sandbox_id = 6 [json_name = "sandbox_id"];
   */
  sandboxId: string;

  /**
   * @gotags: json:"sandbox_class_id"
   *
   * @generated from field: string sandbox_class_id = 7 [json_name = "sandbox_class_id"];
   */
  sandboxClassId: string;

  /**
   * @gotags: json:"agent_id"
   *
   * @generated from field: string agent_id = 8 [json_name = "agent_id"];
   */
  agentId: string;

  /**
   * @gotags: json:"trace_id"
   *
   * @generated from field: string trace_id = 9 [json_name = "trace_id"];
   */
  traceId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.SandboxTraceRecord.
 * Use `create(SandboxTraceRecordSchema)` to create a new message.
 */
export const SandboxTraceRecordSchema: GenMessage<SandboxTraceRecord> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 16);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSandboxClassesResponse
 */
export type ListSandboxClassesResponse = Message<"infinigence.infini.agentplatform.httpv2.ListSandboxClassesResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListSandboxClassesData data = 4;
   */
  data?: ListSandboxClassesData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSandboxClassesResponse.
 * Use `create(ListSandboxClassesResponseSchema)` to create a new message.
 */
export const ListSandboxClassesResponseSchema: GenMessage<ListSandboxClassesResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 17);

/**
 * List 字段量大，按 spec §3.3 例外条款允许直接复用资源 message。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSandboxClassesData
 */
export type ListSandboxClassesData = Message<"infinigence.infini.agentplatform.httpv2.ListSandboxClassesData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.SandboxClass items = 1;
   */
  items: SandboxClass[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSandboxClassesData.
 * Use `create(ListSandboxClassesDataSchema)` to create a new message.
 */
export const ListSandboxClassesDataSchema: GenMessage<ListSandboxClassesData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 18);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateSandboxClassRequest
 */
export type CreateSandboxClassRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateSandboxClassRequest"> & {
  /**
   * Sandbox 服务类定义（归属 tenant_id / user_id 由服务端从鉴权信息回填）
   * @gotags: json:"sandbox_class"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SandboxClass sandbox_class = 1 [json_name = "sandbox_class"];
   */
  sandboxClass?: SandboxClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateSandboxClassRequest.
 * Use `create(CreateSandboxClassRequestSchema)` to create a new message.
 */
export const CreateSandboxClassRequestSchema: GenMessage<CreateSandboxClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 19);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateSandboxClassResponse
 */
export type CreateSandboxClassResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateSandboxClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SandboxClass data = 4;
   */
  data?: SandboxClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateSandboxClassResponse.
 * Use `create(CreateSandboxClassResponseSchema)` to create a new message.
 */
export const CreateSandboxClassResponseSchema: GenMessage<CreateSandboxClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 20);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSandboxClassRequest
 */
export type GetSandboxClassRequest = Message<"infinigence.infini.agentplatform.httpv2.GetSandboxClassRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSandboxClassRequest.
 * Use `create(GetSandboxClassRequestSchema)` to create a new message.
 */
export const GetSandboxClassRequestSchema: GenMessage<GetSandboxClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 21);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSandboxClassResponse
 */
export type GetSandboxClassResponse = Message<"infinigence.infini.agentplatform.httpv2.GetSandboxClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SandboxClass data = 4;
   */
  data?: SandboxClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSandboxClassResponse.
 * Use `create(GetSandboxClassResponseSchema)` to create a new message.
 */
export const GetSandboxClassResponseSchema: GenMessage<GetSandboxClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 22);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateSandboxClassRequest
 */
export type UpdateSandboxClassRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateSandboxClassRequest"> & {
  /**
   * 待更新 Sandbox 服务类 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Sandbox 服务类定义（归属由服务端回填）
   * @gotags: json:"sandbox_class"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SandboxClass sandbox_class = 2 [json_name = "sandbox_class"];
   */
  sandboxClass?: SandboxClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateSandboxClassRequest.
 * Use `create(UpdateSandboxClassRequestSchema)` to create a new message.
 */
export const UpdateSandboxClassRequestSchema: GenMessage<UpdateSandboxClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 23);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateSandboxClassResponse
 */
export type UpdateSandboxClassResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateSandboxClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SandboxClass data = 4;
   */
  data?: SandboxClass | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateSandboxClassResponse.
 * Use `create(UpdateSandboxClassResponseSchema)` to create a new message.
 */
export const UpdateSandboxClassResponseSchema: GenMessage<UpdateSandboxClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 24);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteSandboxClassRequest
 */
export type DeleteSandboxClassRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteSandboxClassRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteSandboxClassRequest.
 * Use `create(DeleteSandboxClassRequestSchema)` to create a new message.
 */
export const DeleteSandboxClassRequestSchema: GenMessage<DeleteSandboxClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 25);

/**
 * 删除幂等：成功 / 不存在都返回 HTTP 200，envelope code "200"，不带 data
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteSandboxClassResponse
 */
export type DeleteSandboxClassResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteSandboxClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteSandboxClassResponse.
 * Use `create(DeleteSandboxClassResponseSchema)` to create a new message.
 */
export const DeleteSandboxClassResponseSchema: GenMessage<DeleteSandboxClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 26);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateSandboxInstanceFromClassRequest
 */
export type CreateSandboxInstanceFromClassRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateSandboxInstanceFromClassRequest"> & {
  /**
   * Sandbox 服务类 ID
   * @gotags: json:"class_id"
   *
   * @generated from field: string class_id = 1 [json_name = "class_id"];
   */
  classId: string;

  /**
   * 实例名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 实例描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * 类参数取值
   * @gotags: json:"params,omitempty"
   *
   * @generated from field: map<string, string> params = 4;
   */
  params: { [key: string]: string };
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateSandboxInstanceFromClassRequest.
 * Use `create(CreateSandboxInstanceFromClassRequestSchema)` to create a new message.
 */
export const CreateSandboxInstanceFromClassRequestSchema: GenMessage<CreateSandboxInstanceFromClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 27);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateSandboxInstanceFromClassResponse
 */
export type CreateSandboxInstanceFromClassResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateSandboxInstanceFromClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Sandbox data = 4;
   */
  data?: Sandbox | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateSandboxInstanceFromClassResponse.
 * Use `create(CreateSandboxInstanceFromClassResponseSchema)` to create a new message.
 */
export const CreateSandboxInstanceFromClassResponseSchema: GenMessage<CreateSandboxInstanceFromClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 28);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateSandboxInstanceFromClassRequest
 */
export type UpdateSandboxInstanceFromClassRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateSandboxInstanceFromClassRequest"> & {
  /**
   * Sandbox 服务类 ID
   * @gotags: json:"class_id"
   *
   * @generated from field: string class_id = 1 [json_name = "class_id"];
   */
  classId: string;

  /**
   * 待更新 Sandbox 实例 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * 实例名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 实例描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * 类参数取值
   * @gotags: json:"params,omitempty"
   *
   * @generated from field: map<string, string> params = 5;
   */
  params: { [key: string]: string };
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateSandboxInstanceFromClassRequest.
 * Use `create(UpdateSandboxInstanceFromClassRequestSchema)` to create a new message.
 */
export const UpdateSandboxInstanceFromClassRequestSchema: GenMessage<UpdateSandboxInstanceFromClassRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 29);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateSandboxInstanceFromClassResponse
 */
export type UpdateSandboxInstanceFromClassResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateSandboxInstanceFromClassResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Sandbox data = 4;
   */
  data?: Sandbox | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateSandboxInstanceFromClassResponse.
 * Use `create(UpdateSandboxInstanceFromClassResponseSchema)` to create a new message.
 */
export const UpdateSandboxInstanceFromClassResponseSchema: GenMessage<UpdateSandboxInstanceFromClassResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 30);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSandboxSpecsResponse
 */
export type ListSandboxSpecsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListSandboxSpecsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListSandboxSpecsData data = 4;
   */
  data?: ListSandboxSpecsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSandboxSpecsResponse.
 * Use `create(ListSandboxSpecsResponseSchema)` to create a new message.
 */
export const ListSandboxSpecsResponseSchema: GenMessage<ListSandboxSpecsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 31);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSandboxSpecsData
 */
export type ListSandboxSpecsData = Message<"infinigence.infini.agentplatform.httpv2.ListSandboxSpecsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.SandboxSpec items = 1;
   */
  items: SandboxSpec[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSandboxSpecsData.
 * Use `create(ListSandboxSpecsDataSchema)` to create a new message.
 */
export const ListSandboxSpecsDataSchema: GenMessage<ListSandboxSpecsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 32);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSandboxSpecRequest
 */
export type GetSandboxSpecRequest = Message<"infinigence.infini.agentplatform.httpv2.GetSandboxSpecRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSandboxSpecRequest.
 * Use `create(GetSandboxSpecRequestSchema)` to create a new message.
 */
export const GetSandboxSpecRequestSchema: GenMessage<GetSandboxSpecRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 33);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSandboxSpecResponse
 */
export type GetSandboxSpecResponse = Message<"infinigence.infini.agentplatform.httpv2.GetSandboxSpecResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SandboxSpec data = 4;
   */
  data?: SandboxSpec | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSandboxSpecResponse.
 * Use `create(GetSandboxSpecResponseSchema)` to create a new message.
 */
export const GetSandboxSpecResponseSchema: GenMessage<GetSandboxSpecResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 34);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSandboxEnvironmentsResponse
 */
export type ListSandboxEnvironmentsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListSandboxEnvironmentsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListSandboxEnvironmentsData data = 4;
   */
  data?: ListSandboxEnvironmentsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSandboxEnvironmentsResponse.
 * Use `create(ListSandboxEnvironmentsResponseSchema)` to create a new message.
 */
export const ListSandboxEnvironmentsResponseSchema: GenMessage<ListSandboxEnvironmentsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 35);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListSandboxEnvironmentsData
 */
export type ListSandboxEnvironmentsData = Message<"infinigence.infini.agentplatform.httpv2.ListSandboxEnvironmentsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.SandboxEnvironment items = 1;
   */
  items: SandboxEnvironment[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListSandboxEnvironmentsData.
 * Use `create(ListSandboxEnvironmentsDataSchema)` to create a new message.
 */
export const ListSandboxEnvironmentsDataSchema: GenMessage<ListSandboxEnvironmentsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 36);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSandboxEnvironmentRequest
 */
export type GetSandboxEnvironmentRequest = Message<"infinigence.infini.agentplatform.httpv2.GetSandboxEnvironmentRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSandboxEnvironmentRequest.
 * Use `create(GetSandboxEnvironmentRequestSchema)` to create a new message.
 */
export const GetSandboxEnvironmentRequestSchema: GenMessage<GetSandboxEnvironmentRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 37);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSandboxEnvironmentResponse
 */
export type GetSandboxEnvironmentResponse = Message<"infinigence.infini.agentplatform.httpv2.GetSandboxEnvironmentResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.SandboxEnvironment data = 4;
   */
  data?: SandboxEnvironment | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSandboxEnvironmentResponse.
 * Use `create(GetSandboxEnvironmentResponseSchema)` to create a new message.
 */
export const GetSandboxEnvironmentResponseSchema: GenMessage<GetSandboxEnvironmentResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_sandbox, 38);

/**
 * @generated from enum infinigence.infini.agentplatform.httpv2.TraceRecordStatus
 */
export enum TraceRecordStatus {
  /**
   * @generated from enum value: TRACE_RECORD_STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: TRACE_RECORD_STATUS_RUNNING = 1;
   */
  RUNNING = 1,

  /**
   * @generated from enum value: TRACE_RECORD_STATUS_FINISHED = 2;
   */
  FINISHED = 2,
}

/**
 * Describes the enum infinigence.infini.agentplatform.httpv2.TraceRecordStatus.
 */
export const TraceRecordStatusSchema: GenEnum<TraceRecordStatus> = /*@__PURE__*/
  enumDesc(file_agentplatform_httpv2_sandbox, 0);

/**
 * SandboxHTTPV2Service
 * Sandbox 实例 / Sandbox 服务类 / Sandbox 配置 的 CRUD，以及工具列举与 trace 记录查询
 *
 * @generated from service infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service
 */
export const SandboxHTTPV2Service: GenService<{
  /**
   * ---- Sandbox Instance ----
   * 列出 Sandbox 实例（分页 / 过滤）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.ListSandboxes
   */
  listSandboxes: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListSandboxesResponseSchema;
  },
  /**
   * 创建 Sandbox 实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.CreateSandbox
   */
  createSandbox: {
    methodKind: "unary";
    input: typeof CreateSandboxRequestSchema;
    output: typeof CreateSandboxResponseSchema;
  },
  /**
   * 获取单个 Sandbox 实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.GetSandbox
   */
  getSandbox: {
    methodKind: "unary";
    input: typeof GetSandboxRequestSchema;
    output: typeof GetSandboxResponseSchema;
  },
  /**
   * 更新 Sandbox 实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.UpdateSandbox
   */
  updateSandbox: {
    methodKind: "unary";
    input: typeof UpdateSandboxRequestSchema;
    output: typeof UpdateSandboxResponseSchema;
  },
  /**
   * 删除 Sandbox 实例（幂等：已删除返回 200）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.DeleteSandbox
   */
  deleteSandbox: {
    methodKind: "unary";
    input: typeof DeleteSandboxRequestSchema;
    output: typeof DeleteSandboxResponseSchema;
  },
  /**
   * 列出 Sandbox 实例暴露的工具
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.ListSandboxTools
   */
  listSandboxTools: {
    methodKind: "unary";
    input: typeof ListSandboxToolsRequestSchema;
    output: typeof ListSandboxToolsResponseSchema;
  },
  /**
   * 查询 Sandbox trace 记录
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.ListSandboxTraceRecords
   */
  listSandboxTraceRecords: {
    methodKind: "unary";
    input: typeof ListSandboxTraceRecordsRequestSchema;
    output: typeof ListSandboxTraceRecordsResponseSchema;
  },
  /**
   * ---- Sandbox Class ----
   * 列出 Sandbox 服务类（分页 / 过滤）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.ListSandboxClasses
   */
  listSandboxClasses: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListSandboxClassesResponseSchema;
  },
  /**
   * 创建 Sandbox 服务类
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.CreateSandboxClass
   */
  createSandboxClass: {
    methodKind: "unary";
    input: typeof CreateSandboxClassRequestSchema;
    output: typeof CreateSandboxClassResponseSchema;
  },
  /**
   * 获取单个 Sandbox 服务类
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.GetSandboxClass
   */
  getSandboxClass: {
    methodKind: "unary";
    input: typeof GetSandboxClassRequestSchema;
    output: typeof GetSandboxClassResponseSchema;
  },
  /**
   * 更新 Sandbox 服务类
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.UpdateSandboxClass
   */
  updateSandboxClass: {
    methodKind: "unary";
    input: typeof UpdateSandboxClassRequestSchema;
    output: typeof UpdateSandboxClassResponseSchema;
  },
  /**
   * 删除 Sandbox 服务类（幂等：已删除返回 200）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.DeleteSandboxClass
   */
  deleteSandboxClass: {
    methodKind: "unary";
    input: typeof DeleteSandboxClassRequestSchema;
    output: typeof DeleteSandboxClassResponseSchema;
  },
  /**
   * ---- Sandbox Instance from Class ----
   * 基于 Sandbox 服务类创建 Sandbox 实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.CreateSandboxInstanceFromClass
   */
  createSandboxInstanceFromClass: {
    methodKind: "unary";
    input: typeof CreateSandboxInstanceFromClassRequestSchema;
    output: typeof CreateSandboxInstanceFromClassResponseSchema;
  },
  /**
   * 基于 Sandbox 服务类更新 Sandbox 实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.UpdateSandboxInstanceFromClass
   */
  updateSandboxInstanceFromClass: {
    methodKind: "unary";
    input: typeof UpdateSandboxInstanceFromClassRequestSchema;
    output: typeof UpdateSandboxInstanceFromClassResponseSchema;
  },
  /**
   * ---- Sandbox Config (Spec & Environment) ----
   * 列出 Sandbox 规格（含租户可见性过滤）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.ListSandboxSpecs
   */
  listSandboxSpecs: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListSandboxSpecsResponseSchema;
  },
  /**
   * 获取单个 Sandbox 规格
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.GetSandboxSpec
   */
  getSandboxSpec: {
    methodKind: "unary";
    input: typeof GetSandboxSpecRequestSchema;
    output: typeof GetSandboxSpecResponseSchema;
  },
  /**
   * 列出 Sandbox 环境（含租户 + 公共环境）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.ListSandboxEnvironments
   */
  listSandboxEnvironments: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListSandboxEnvironmentsResponseSchema;
  },
  /**
   * 获取单个 Sandbox 环境
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.SandboxHTTPV2Service.GetSandboxEnvironment
   */
  getSandboxEnvironment: {
    methodKind: "unary";
    input: typeof GetSandboxEnvironmentRequestSchema;
    output: typeof GetSandboxEnvironmentResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_agentplatform_httpv2_sandbox, 0);

